//React
import React, { useEffect, useState } from 'react';
//Компоненты
import Counter from '../../../../../components/counter';
import Products from '../../../../../components/products';
import Input from '../../../../../components/input';
import Button from '../../../../../../../components/button';
//Стили
import "./styles.css";
import "../../../styles.css";
import { Checkbox, FormHelperText } from '@mui/material';
import CONFIG from '../../../../../../../../inc/Config';

export default function Card({
  isAvailable = false,
  hasPromo = true,
  selectedSlot,
  countPeople,
  handleCountChange,
  productTime,
  productType,
  minutesByMainProducts,
  minutesByAdditionalProducts,
  handleProductChange,
  promocodeErrors,
  promocodeWarnings = [],
  promocodeString,
  setPromocodeString,
  promocodeLabel,
  handleBookByCard,
  setAgreement = () => {},
  agreement = false,
  children
}){
    useEffect(() => {
        handleProductChange(null);
    }, [])

    const handleButtonClick = () => {
        if (isAvailable && agreement) {
            handleBookByCard();
        }
    }
  return (
    <div className="step-buy__content-body">
      <div className="step-buy__content-row">
        <label className="step-buy__content-row_label">Человек</label>
        <Counter
          className="step-buy__content-row_item"
          countPeople={countPeople}
          onChange={handleCountChange}
          max={15}
        />
      </div>
      <div className="step-buy__content-row">
        <label className="step-buy__content-row_label">Время (мин)</label>
        <Products
          className="step-buy__content-row_item"
          selectedSlot={selectedSlot}
          selectedProduct={productTime}
          products={productType === 'main' ? minutesByMainProducts : minutesByAdditionalProducts}
          countPeople={countPeople}
          onChange={handleProductChange}
        />
      </div>
      {children}
      {hasPromo ? 
        <div className="step-buy__content-row">
            <Input
            errors={promocodeErrors}
            value={promocodeString}
            onChange={(e) => setPromocodeString(e.target.value)}
            className={`step-buy__content-row_item--last`}
            >
                Промокод
            </Input>
            {promocodeLabel && promocodeString && (
            <div className="step-buy__content-row_success-label">{promocodeLabel}</div>
            )}
            {promocodeWarnings.length > 0 ?
                promocodeWarnings.map((warning, key)=>{
                    return <FormHelperText
                        key={key} 
                        sx={{color: "orange"}}
                    >{warning}</FormHelperText>
                })
            : null}
        </div>
      : null }
      <div className='step-buy__content-row--agreement'>
        <div  className='agreement_checkbox'>
            <Checkbox
                value={agreement}
                onChange={setAgreement}
                sx={{padding:0}}
            />
        </div>
        <div>Подтверждаю ознакомление с <a target="_blank" href={CONFIG.fileRoutes.privacy}>Политикой конфиденциальности</a> ООО «АЭРОДИНАМИКА» и <a target="_blank" href={CONFIG.fileRoutes.agreement}>Клиентским соглашением</a></div>
      </div>
      <Button className={`${!isAvailable || !agreement ? "step-buy__content-button--disable" : "step-buy__content-button"}`} onClick={handleButtonClick}>
        Оформить
      </Button>
    </div>
  );
};
